import { ChevronDownIcon, CheckIcon } from "@heroicons/react/20/solid";
import { Dropdown, DropdownButton, DropdownBody, DropdownItem } from "@components/atoms/Dropdown";
import { METRIC_PERIODS } from "../hooks/useTaskMetrics";

// Text + chevron period selector used by the metrics surfaces. `position` places the menu.
// `label` overrides the button text (default: the period's own label); `buttonClassName` overrides
// the button styling — the metrics card uses both to render it as a "Collected this month" heading.
const PeriodSelect = ({
  value,
  onChange,
  position = "left",
  label,
  buttonClassName = "flex cursor-pointer items-center gap-1 text-[13px] font-medium text-zinc-500 hover:text-zinc-800",
}) => {
  const active = METRIC_PERIODS.find((p) => p.key === value) ?? METRIC_PERIODS[0];

  return (
    <Dropdown className="w-fit">
      <DropdownButton className={buttonClassName}>
        <span>{label ?? active.label}</span>
        <ChevronDownIcon className="size-3.5 text-zinc-400" aria-hidden="true" />
      </DropdownButton>
      <DropdownBody position={position} className="w-40">
        {METRIC_PERIODS.map((p) => (
          <DropdownItem key={p.key} onClick={() => onChange(p.key)} closeOnComplete>
            <span className="flex items-center justify-between gap-2 text-sm">
              {p.label}
              {p.key === active.key && <CheckIcon className="size-4 text-primary-500" />}
            </span>
          </DropdownItem>
        ))}
      </DropdownBody>
    </Dropdown>
  );
};

export default PeriodSelect;
